/* loaded by smart-asset */
export default require("./exclamation-triangle-solid~beTpBYzL.svg")